__webpack_require__.p = "https://insider.proposals.microsoft.com/";